<div class="paginator-holder">
  <div class="paginator-buttons">
    <button
      class="clear-padding left-btn"
      nbButton
      (click)="setPage(1)"
      [disabled]="pageCount < 0 || activePage < 2"
      [title]="'paginate_first_page'| translation"
    >
      <nb-icon pack="fas" icon="backward"></nb-icon>
    </button>
    <button
      nbButton
      (click)="setPage(activePage - 1)"
      [disabled]="activePage < 2"
      [title]="'paginate_previous_page'| translation"
    >
      <nb-icon pack="fas" icon="caret-left"></nb-icon>
    </button>
    <button
      *ngIf="activePage == pageCount && pageCount > 2"
      nbButton
      (click)="setPage(activePage - 2)"
    >
      {{ activePage - 2 }}
    </button>
    <button nbButton (click)="setPage(activePage - 1)" *ngIf="activePage > 1">
      {{ activePage - 1 }}
    </button>
    <button nbButton class="active-btn">
      {{ activePage }}
    </button>
    <button
      [disabled]="!itemCount"
      nbButton
      (click)="setPage(activePage + 1)"
      *ngIf="pageCount > 1 && activePage != pageCount"
    >
      {{ activePage + 1 }}
    </button>
    <button
      [disabled]="!itemCount"
      *ngIf="activePage == 1 && pageCount > 2"
      nbButton
      (click)="setPage(activePage + 2)"
    >
      {{ activePage + 2 }}
    </button>
    <button
      nbButton
      (click)="setPage(activePage + 1)"
      [disabled]="!itemCount||activePage >= pageCount"
      [title]="'next_page'|translation"
    >
      <nb-icon pack="fas" icon="caret-right"></nb-icon>
    </button>
    <button
      class="clear-padding right-btn"
      nbButton
      (click)="setPage(pageCount)"
      [disabled]="!itemCount||pageCount <= 2 || activePage >= pageCount"
      [title]="'last_page'|translation"
    >
      <nb-icon pack="fas" icon="forward"></nb-icon>
    </button>
  </div>
</div>
<!-- avoding showing paginator at all if not item count none or just one page-->
<!-- <div class="paginator-holder" *ngIf="!itemCount">
  <div class="paginator-buttons">
    <button
      class="clear-padding left-btn"
      nbButton
      (click)="setPage(1)"
      [disabled]="pageCount < 2 || activePage < 2"
      title="First Page"
    >
      <nb-icon pack="fas" icon="backward"></nb-icon>
    </button>
    <button
      nbButton
      (click)="setPage(activePage - 1)"
      [disabled]="activePage < 2 || !itemCount"
      title="Previous Page"
    >
      <nb-icon pack="fas" icon="caret-left"></nb-icon>
    </button>
    <button nbButton class="active-btn">
      {{ activePage }}
    </button>
    <button
      nbButton
      [disabled]="activePage >= pageCount||!itemCount"
      (click)="setPage(activePage + 1)"
      title="Next Page"
    >
      <nb-icon pack="fas" icon="caret-right"></nb-icon>
    </button>
    <button
      class="clear-padding right-btn"
      nbButton
      (click)="setPage(pageCount)"
      [disabled]="pageCount <= 3 || activePage >= pageCount"
      title="Last Page"
    >
      <nb-icon pack="fas" icon="forward"></nb-icon>
    </button>
  </div>
</div> -->
